import OverviewPlugin from './OverviewPlugin';

export default OverviewPlugin;
